var _linearGradient, _circle, _circle2, _circle3, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTcapCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 178.58,
    x2: 333.42,
    y1: 43.3,
    y2: 468.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a440f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#9f47ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#915ae7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7a7ad9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#5ba5c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38d6b2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#1d1d3c",
    r: 256
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#a)",
    r: 226.29
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#1d1d3c",
    r: 210.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m362.77 117h-249.13v142.32h71.18v142.36h142.36v-142.36h71.18v-142.32z",
    fill: "#1d1d3c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m321.34 157.28h-32.67-32.67-32.67-32.67-32.67v32.67h32.67 32.67v32.67 32.67 32.67 32.67h32.67 32.67v-32.67-32.67-32.67-32.67h32.67 32.67v-32.67z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m220.41 361.69h71.18v8.79h-71.18z",
    fill: "#38d6b2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcapCoin);
export default __webpack_public_path__ + "static/media/tcap-coin.b7ed335a93602299d0c3cc863c429536.svg";
export { ForwardRef as ReactComponent };